<template>
  <div id="kakaoFoot" class="k_foot">
    <div class="inner_foot">
      <ul class="list_service">
        <li><a href="https://www.dktechin.co.kr/" target="_blank" class="link_service">회사소개</a></li>
        <li><button class="link_service" @click="onClickPolicy('terms')">이용약관</button></li>
        <li><button class="link_service" @click="onClickPolicy('privacy')"><em class="link_line">개인정보처리방침</em></button></li>
      </ul>
      <dl class="list_info">
        <dt class="screen_out">회사명</dt>
        <dd>(주)디케이테크인</dd>
        <dt class="screen_out">회사주소</dt>
        <dd>경기도 성남시 분당구 판교역로 235, 에이치스퀘어 N동 3층</dd>
        <dt>대표이사 :</dt>
        <dd>이원주</dd>
        <dt>대표전화 :</dt>
        <dd>031-606-4600</dd>
        <dt>대표이메일 :</dt>
        <dd class="dd_full">tfac.biz@kakaocorp.com</dd>
        <dt>사업제휴문의 : </dt>
        <dd>dkt.biz@kakaocorp.com</dd>
        <dt>사업자등록번호 :</dt>
        <dd>606-87-00134</dd>
        <dt class="screen_out">사업자 정보</dt>
        <dd>
          <a class="link_info" href="http://www.ftc.go.kr/bizCommPop.do?wrkr_no=6068700134" onClick="window.open(this.href,'사업자 정보 확인','width=1030px,height=850px,top=0,left=0');return false;">사업자 정보 확인</a>
        </dd>
        <dt>통신판매신고번호 :</dt>
        <dd>7496725374950</dd>

      </dl>
      <small class="txt_copy">Copyright dk techin Co.,Ltd All rights reserved.</small>
      <div class="isms">
        <img src="https://t1.kakaocdn.net/smartfactory/icons/ISMS-P_%EA%B0%95%EC%A1%B0%202.png" class="isms_logo" alt="ISMS-P">
        <div>
          <div>인증범위 : T-fac 스마트 플랫폼</div>
          <div>유효기간 : 2022-12-21 ~ 2025-12-20</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tooltipControlMixin from '@/mixins/tooltipControl';
export default {
  name: 'Footer',
  mixins: [tooltipControlMixin],
  data(){
    return{

    }
  },
  mounted() {

  },
  methods:{
    onClickPolicy(type){
      //window.location.href=`${process.env.VUE_APP_POLICY_URL}/policy/${type}`
      if(type === 'terms') {
        window.open(`${process.env.VUE_APP_POLICY_URL}/service/t-fac`,'_blank');
      } else {
        window.open(`${process.env.VUE_APP_POLICY_URL}/privacy-policy`,'_blank');
      }
    },
    onClickService(e){
      e.stopPropagation();
      this.tooltipControl(); // tooltipControlMixin 메서드
    },

  }
}
</script>

<style scoped>
.k_foot{padding:44px 0 70px;background-color:#111}
.k_foot .inner_foot{position:relative;width:1080px;margin:0 auto}
.k_foot .list_service{overflow:hidden;height:56px; display: flex;align-items: center;}
.k_foot .list_service li{float:left}
.k_foot .list_service li + li{margin-left:50px}
.k_foot .link_service{display:block;font-size:16px;line-height:24px;color:#fff;outline:none}
.k_foot .link_service em{font-weight:bold}

.k_foot .select_service{position:absolute;top:0;right:0}
.k_foot .select_service.on .list_select{display:block}
.k_foot .btn_service{display:block;width:180px;padding-bottom:8px;border-bottom:1px solid #555;font-size:16px;line-height:24px;color:#fff;text-align:left;letter-spacing:-.05em;outline:none}
.k_foot .btn_service .ico_select_service{float:right;margin:9px 5px 0 0}
.k_foot .list_select{display:none;position:absolute;bottom:100%;left:0;right:0;margin-bottom:12px;padding:14px 0;border:1px solid #222;border-radius:2px;background-color:#fff}
.k_foot .list_select li + li{margin-top:12px}
.k_foot .list_select .link_select{display:block;height:34px;padding:10px 20px 0;font-size:14px;line-height:1;color:#222;letter-spacing:-.05em;box-sizing:border-box}
.k_foot .list_select .link_select:hover{background-color:#FFFCE5}

.k_foot .list_info{overflow:hidden;padding-top:24px;font-size:15px;line-height:23px;color:#888;letter-spacing:-.05em}
.k_foot .list_info dt,
.k_foot .list_info dd{float:left}
.k_foot .list_info dt{padding-right:3px}
.k_foot .list_info dd + .screen_out + dd{margin-left:10px}
.k_foot .list_info .dd_full{float:none;overflow:hidden}
.k_foot .list_info .dd_full + dt{margin-left:0}
.k_foot .list_info dd + dt{margin-left:50px}
.k_foot .txt_copy{display:block;margin-top:16px;font-weight:normal;font-size:13px;line-height:20px;color:#888}
.k_foot .list_info .link_info{color:#888;text-decoration:underline}

.link_line{text-decoration: underline}

.isms {
  display: flex;
  gap:15px;
  align-items: center;
  position:absolute;
  right:0;
  top:0;
  color:#BCBBBB;
  font-size:15px;
}
</style>
